import { Result } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { projectDetailsSelector } from 'src/features'
import { CustomCard, ProjectDetails } from 'src/components'

const ProjectDetailsPageContent = () => {
  const { t } = useTranslation()
  const { loading, project } = useAppSelector(projectDetailsSelector)
  const isErrorOnLoading = !loading && !project

  return (
    <CustomCard loading={loading}>
      {isErrorOnLoading ? (
        <Result title={t('Projects.Details.ErrorLoading')}/>
      ): project && (
        <ProjectDetails project={project}/>
      )}
    </CustomCard>
  )
}

export default ProjectDetailsPageContent
